<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card border-variant="primary">
          <b-card-body class="pb-0">
            <b-alert variant="success" show class="text-center">{{ t('support_info') }}</b-alert>
            <b-form-group>
              <b-form-input :placeholder="t('support_title')" type="text" v-model="form.title"></b-form-input>
            </b-form-group>
            <b-form-group>
              <b-form-textarea
                :placeholder="t('support_message')"
                :rows="3"
                :max-rows="6"
                v-model="form.content">
              </b-form-textarea>
            </b-form-group>
            <b-button type="submit" block variant="primary" @click="onSubmit()">{{ t('global_submit') }}</b-button>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'Support',
  data: () => {
    return {
      form: {
        title: '',
        content: ''
      }
    }
  },
  methods: {
    onSubmit () {
      const title = this.form.title.trim()
      const content = this.form.content.trim()

      if (title === '' || content === '') {
        Vue.swal(
          this.$translate.text('support_fill'),
          '',
          'warning')
      } else {
        const that = this

        Vue.axios({
          method: 'POST',
          url: '/support',
          data: {
            title,
            content
          },
          mode: 'no-cors',
          withCredentials: true,
          credentials: 'same-origin'
        }).then(response => {
          if (response.data.status) {
            Vue.swal(
              this.$translate.text('support_sent'),
              '',
              'success')
            
            that.form.title = ''
            that.form.content = ''
          } else {
            Vue.swal(
              this.$translate.text(response.data.message ? response.data.message : 'global_an-unexpected-error-occurred'),
              '',
              'warning')
          }
        }).catch(() => {
          Vue.swal(
            this.$translate.text('global_an-unexpected-error-occurred'),
            '',
            'warning')
        })
      }
    }
  }
}
</script>